import React from 'react'
import { BrowserRouter, Routes, Route } from "react-router-dom";

import './App.css'
import SignalPeakLanding from './components/SignalPeakLanding'
import QwikShiftLanding from './components/QwikShiftLanding'
import PocketPortfolioLanding from './components/PocketPortfolioLanding'
import PhotoStoryLanding from './components/PhotoStoryLanding'
import CityVsCityLanding from './components/CityVsCityLanding'
import Help from './components/Help'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<SignalPeakLanding />} />
        <Route path="/qwikshift" element={<QwikShiftLanding />} />
        <Route path="/pocket-portfolio" element={<PocketPortfolioLanding />} />
        <Route path="/photo-story" element={<PhotoStoryLanding />} />
        <Route path="/city-vs-city" element={<CityVsCityLanding />} />
        <Route path="/qwikshift/help" element={<Help />} />
        <Route path="/pocket-portfolio/help" element={<Help />} />
        <Route path="/photo-story/help" element={<Help />} />
        <Route path="/city-vs-city/help" element={<Help />} />
        <Route path="*" element={<SignalPeakLanding />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App